"use client"

import { cn } from "@coval/ui/cn"

import { useDelayedUnmount } from "../hooks/useDelayedUnmount"

const CARET_KEYFRAMES = `
@keyframes covi-voiceprint-flicker {
  0%, 100% { transform: scaleY(0.35); }
  50% { transform: scaleY(1); }
}
.covi-voiceprint-bar {
  transform: scaleY(0.45);
  transform-origin: bottom;
  animation: covi-voiceprint-flicker 0.9s ease-in-out infinite;
}
@media (prefers-reduced-motion: reduce) {
  .covi-voiceprint-bar {
    animation: none;
  }
}
`

/**
 * Streaming caret: a 3-bar micro-waveform that flickers at the end of the
 * reply while it streams in, then fades out (150ms) on completion. Today's
 * Sofia turns land as a single message, so the caret effectively pre-wires
 * the upcoming token-streaming channel. Respects prefers-reduced-motion
 * (static bars).
 */
export function VoiceprintCaret({ active }: { active: boolean }) {
  const { mounted, leaving } = useDelayedUnmount(active, 150)
  if (!mounted) {
    return null
  }
  return (
    <span
      aria-hidden="true"
      data-testid="voiceprint-caret"
      className={cn(
        "ml-0.5 inline-flex h-3 items-end gap-px text-coval-text-muted transition-opacity duration-150 ease-out",
        leaving ? "opacity-0" : "opacity-100",
      )}
    >
      <style>{CARET_KEYFRAMES}</style>
      <span className="covi-voiceprint-bar h-2 w-0.5 rounded-full bg-current [animation-delay:-0.6s]" />
      <span className="covi-voiceprint-bar h-3 w-0.5 rounded-full bg-current [animation-delay:-0.3s]" />
      <span className="covi-voiceprint-bar h-2.5 w-0.5 rounded-full bg-current" />
    </span>
  )
}
